import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Divider, Grid } from '@material-ui/core';
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHMMFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch, statementPeriodOption } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import { DownIcon, UpIcon } from '../../components/icons';
import { Field, Form } from 'react-final-form';
import { DatePickerComponent, SelectComponent, TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import { domainName } from '../../../portal.config';

const drawerWidth = 520;
const contentHeight = window.innerHeight -100

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        margin: theme.spacing(3, 0),
        border: '1px solid',
        borderColor: theme.palette.background.card,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
    item: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    listItem: {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
        backgroundColor: theme.palette.background.secondary
    },

    image_bg: {
        width: 40,
        height: 40,
        borderRadius: 40,
        backgroundColor: theme.palette.background.transparent
    },
    image: {
        width: 40,
        height: 40,
        resizeMode: 'contain'
    },

    status: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        ...theme.palette.button.danger,
    },
    statusAdHoc: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        textAlign: "center",
        alignItems: "center",
        height: 'fit-content',
        backgroundColor: theme.palette.background.other,
        color: theme.palette.text.onPrimary,
    },
    box: {
        padding: theme.spacing(2, 2, 0, 0)
    },
    box_first: {
        paddingTop: theme.spacing(2)
    },
    box_second: {
        paddingTop: theme.spacing(1)
    },
    form: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(3,4),
        margin: theme.spacing(2, 0),
        border: '1px solid',
        borderColor: theme.palette.background.card,
    },
});

function AccountAnalysisView(props) {
    const { classes, t, transactions, currency, handleLoadMore, showLoadMore, hasMore, showLoading, accountFinance, transactionDetail, showTransactionDetail } = props;
    console.log("props AccountAnalysisView==", props);
    let balance = accountFinance && accountFinance.balance ? accountFinance.balance : 0;
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.handleDrawerOtherToggle('account_analysis')}
                title={t('account_analysis')}
                children={
                    <Grid item>
                        <Grid item container justify='center' alignItems='center'>
                            {showLoading && <CustomizedCircularProgress />}
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <ButtonCustom fullWidth round={false} color={'primary'}>
                                <CustomTypo variant="subtitle2">{currency}{balance.toFixed(2)}</CustomTypo>
                            </ButtonCustom>
                        </Grid>
                        {domainName === 'ayna' && document._portalConfig.usePaymentLocal && <Grid item xs={12} className={classes.form}>
                            <Form
                                onSubmit={props.onTopup}
                                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                    <Grid item xs={12} className={classes.filter}>
                                        <Grid item xs={12} container alignItems='center' className={classes.period}>
                                            <Grid item xs={12} container alignItems='center'>
                                                <Grid item xs={12} md={2}>
                                                    <CustomTypo mg_left_md variant="input_label" color='default'>{t('topup_local_amount')}</CustomTypo>
                                                </Grid>
                                                <Grid item xs={12} md={10} container alignItems='center'>
                                                    <Grid item xs={12}>
                                                        <Field
                                                            name="amount"
                                                            component={TextFieldComponent}
                                                            placeholder={t('enter_amount')}
                                                            isEdit={true}
                                                            color='default'
                                                            valuez={props.amount}
                                                            onCustomChange={props.onChangeInput}
                                                            validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item md={12} container justifyContent='flex-end'>
                                            <ButtonCustom color='primary' size='sm' onClick={handleSubmit}>{t('btn_submit')}</ButtonCustom>
                                        </Grid>
                                    </Grid>
                                )}
                            />
                        </Grid>}
                        <Grid item xs={12} className={classes.form}>
                            <Form
                                onSubmit={props.onFilter}
                                initialValues={{ ...props.specificPeriod }}
                                render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                    <Grid item xs={12} className={classes.filter}>
                                        {/* <FormAutoSave debounce={1000} save={props.onFilter} /> */}
                                        <Grid item xs={12} container alignItems='center' className={classes.period}>
                                            <Grid item xs={12} container alignItems='center'>
                                                <Grid item xs={12} md={2}>
                                                    <CustomTypo mg_left_md variant="input_label" color='default'>{t('period_title')}</CustomTypo>
                                                </Grid>
                                                <Grid item xs={12} md={10} container alignItems='center'>
                                                    <Grid item xs={12}>
                                                        <Field
                                                            name="period"
                                                            // label={t('period_title')}
                                                            component={SelectComponent}
                                                            selectData={props.listPeriods}
                                                            valueSelect={props.periodSeleted}
                                                            onSelectedChange={(event) => props.onSelectPeriod(event)}
                                                            color='default'
                                                            placeholder={t('Select')}
                                                            isEdit={true}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {props.periodSeleted == statementPeriodOption.SPECIFIC_PERIOD && <>
                                            <Grid item xs={12} container>
                                                <Grid item xs={12} md={6} style={{paddingRight: 8}}>
                                                    <Field
                                                        name="from_date"
                                                        component={DatePickerComponent}
                                                        label={t('from_date')}
                                                        color='default'
                                                        isEdit={true}
                                                        valuez={props.specificPeriod.from_date}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Field
                                                        name="to_date"
                                                        component={DatePickerComponent}
                                                        label={t('to_date')}
                                                        color='default'
                                                        isEdit={true}
                                                        valuez={props.specificPeriod.to_date}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </>}
                                        <Grid item md={12} container justifyContent='flex-end'>
                                            <ButtonCustom color='primary' size='sm' onClick={handleSubmit}>{t('btn_submit')}</ButtonCustom>
                                        </Grid>
                                    </Grid>
                                )}
                            />
                        </Grid>
                        {transactions && <Grid xs={12} item>
                            <InfiniteScroll
                                dataLength={transactions.length} //This is important field to render the next data
                                next={handleLoadMore}
                                hasMore={hasMore}
                                loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                                height={contentHeight}
                            >
                                <Grid xs={12} item>
                                    {transactions.map((item, index) => <AccountAnalysisItem
                                        classes={classes}
                                        key={index}
                                        t={t}
                                        item={item} currency={currency}
                                        transactionDetail={transactionDetail}
                                        showDetail={showTransactionDetail}
                                        onClickDetail={props.onClickDetail} />
                                    )}
                                </Grid>
                            </InfiniteScroll>
                        </Grid>}
                    </Grid>
                } />

        </div>
    );
}

function AccountAnalysisItem(props) {
    const { item, classes, currency, t, transactionDetail } = props
    const [showDetail, setShowDetail] = useState(false);
    // var showDetail = props.showDetail && invoiceDetail && invoiceDetail.id && invoiceDetail.id === item.id;
    var invoice = transactionDetail && transactionDetail.invoice ? transactionDetail.invoice : null;

    return (
        <div>
            <Grid xs={12} item container className={classes.boxItemContent} onClick={() => {
                setShowDetail(!showDetail);
                // if(transactionDetail && transactionDetail.id && transactionDetail.id !== item.id) props.onClickDetail(item);
            }}>
                <Grid xs={12} item container direction='row' alignItems='center'>
                    <Grid item xs={9}>
                        <Grid item xs={12} container alignItems='center'>
                            <CustomTypo mg_top_sm variant='body2' color='secondary'>
                                {item.posted_date ? formatDateToDDMMYYYYHHMMFrEpoch(item.posted_date, false) : ""}
                            </CustomTypo>
                            <CustomTypo mg_top_sm mg_left_sm variant='subtitle2' color={item.type == "CREDIT" ? 'success' : 'error'}>
                                {currency}{item.amount ? item.amount.toFixed(2) : "0.00"}
                            </CustomTypo>
                            <CustomTypo mg_top_sm mg_left_xl size="xs" color={'success'} variant='subtitle2'>
                                {getType(item.transaction_type, t)}
                            </CustomTypo>
                        </Grid>
                    </Grid>
                    <Grid item xs={3} container justify='flex-end'>
                        {showDetail ? <UpIcon /> : <DownIcon />}
                    </Grid>
                </Grid>
                {/* <Grid xs={12} item container alignItems='center'>
                    <Grid item xs={2} xl={1}>
                    </Grid>
                    <Grid item xs={10} xl={11}>
                    </Grid>
                </Grid> */}
                {showDetail && <Grid item xs={12} className={classes.box}>
                    <Divider />
                    {item.number && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        {/* <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_number')}</CustomTypo>
                        </Grid> */}
                        <Grid item xs={6} container>
                            <CustomTypo variant='body2'>{item.number}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {/* {item.issued_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_issued_date')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.issued_date)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {item.posted_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('invoice_posted_date')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.posted_date)}</CustomTypo>
                        </Grid>
                    </Grid>} */}
                    {item && item.invoice && item.invoice.due_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <CustomTypo variant='body1'>{t('invoice_due_date')}: </CustomTypo>
                        <CustomTypo variant='body1' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.invoice.due_date)}</CustomTypo>
                    </Grid>}
                    {/* {transactionDetail && transactionDetail.net > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('net_title')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{transactionDetail.net.toFixed(2)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {transactionDetail && transactionDetail.tax > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('tax_title')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{transactionDetail.tax.toFixed(2)}</CustomTypo>
                        </Grid>
                    </Grid>}
                    {invoice && invoice.overdue_amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('overdue_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{invoice.overdue_amount ? invoice.overdue_amount.toFixed(2) : "0.00" }</CustomTypo>
                        </Grid>
                    </Grid>}
                    {invoice && invoice.unpaid_amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                        <Grid item xs={6}>
                            <CustomTypo variant='body1'>{t('unpaid_amount')}</CustomTypo>
                        </Grid>
                        <Grid item xs={6} container justify='flex-end'>
                            <CustomTypo variant='body1'>{currency}{invoice.unpaid_amount ? invoice.unpaid_amount.toFixed(2) : "0.00" }</CustomTypo>
                        </Grid>
                    </Grid>} */}
                </Grid>}
            </Grid>

        </div>
    )
}

function getType(type, t) {
    if (type == 'INVOICE')
        return t("invoice_title");
    else if (type == 'TOP_UP')
        return t("topup_title");
    else if (type == 'CREDIT_NOTE')
        return t("credit_note");
    else if (type == 'PAYMENT')
        return t("payment");
    else if (type == 'REFUND')
        return t("refund");
    else if (type == 'PAYOUT')
        return t("payout");
    else if (type == 'TRANSFER')
        return t("transfer");
    else if (type == 'MANUAL_JOURNAL')
        return t("manual_journal");
    else return type;
}

export default withStyles(styles)(withTranslation()(AccountAnalysisView));